import React from 'react';
import PropTypes from 'prop-types';
import {Checkbox, Collapse, Icon, message} from 'antd';
import {FormattedMessage, injectIntl} from 'react-intl';
import {withApollo} from 'react-apollo';
import {ALL_PROJECTS} from '../projects/gql/query';
import {withRouter} from 'react-router-dom'

const CheckboxGroup = Checkbox.Group;
const Panel = Collapse.Panel;

class ProjectsFilter extends React.Component {
  static propTypes = {
    onChange: PropTypes.func,
  }

  constructor(props) {
    super(props);
    this.state = {projects: null};
  }

  handleInternalError = (err) => {
    console.error(err);
    const { formatMessage } = this.props.intl;
    message.error(formatMessage({id: 'general.network-error',
      defaultMessage: 'Network error, try again later'}));
  }

  componentWillMount() {
    this.loadProjects()
  }

  loadProjects() {
    if (this.state.projects === null) {
      this.props.client
        .query({query: ALL_PROJECTS})
        .then(({data: {allProjects}}) => {
          this.setState({projects: allProjects});
        }).catch(this.handleInternalError);
    }
  }

  getProjectsOptions(projects) {
    return projects.map((project, i) => {
      return { value: project.id, label: project.title };
    });
  }

  onCheckAll = (e) => {
    if(e.target.checked) {
      let {projects} = this.state;
      projects = projects || [];
      const values = projects.map((p, i) => (p.id));
      this.props.onChange(values);
    } else {
      this.props.onChange([]);
    }
  }

  render () {
    // Hide filter for route '/dashboard/analytics/lead'
    const location = this.props.location.pathname.split('/')
    if (location.includes('lead')) return null

    const { onChange, checked } = this.props;
    const { projects } = this.state;
    return (
      <Collapse defaultActiveKey={['projects-filter']} className="projects-filter">
        <Panel
          header={
            <span>
              <FormattedMessage id="main-menu.projects" />
              <Icon style={{float: 'right', fontWeight: 'normal', fontSize: '16px'}} type="filter" />
            </span>
          }
          key="projects-filter"
        >
          <div className='group-control'>
            <Checkbox
              size={'large'}
              onChange={this.onCheckAll}
              checked={projects && checked && projects.length === checked.length}
            >
              <span className='label'>
                <FormattedMessage
                  className='label'
                  id="analytics.check-all"
                  defaultMessage='Check all'
                />
              </span>
            </Checkbox>
          </div>
          <CheckboxGroup
            size={'large'}
            value={checked}
            options={this.getProjectsOptions(this.state.projects || [])}
            onChange={onChange}
          />
        </Panel>
      </Collapse>
    )
  }
}

export default withApollo(injectIntl(withRouter(ProjectsFilter)));


// WEBPACK FOOTER //
// ./src/components/dashboard/analytics/projects-filter.js